<template>
    <div class="row w-100 h-100">
        <div class="col-7">
            <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 10%;">
                <TitleCover class="fill">
                    <p class="dv-card-title">历史物料入厂状态</p>
                </TitleCover>
            </div>
            <div class="row h-90">
                <common-chart class="w-100 h-100" :options="historyOption"></common-chart>
            </div>
        </div>
        <div class="col-5">
            <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 10%;">
                <TitleCover class="fill">
                    <p class="dv-card-title">当月物料入厂状态</p>
                </TitleCover>
            </div>
            <div class="row h-90">
                <common-chart class="w-100 h-100" :options="currentOption"></common-chart>
            </div>
        </div>
    </div>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";
import TableChartMixins from "@/components/echarts-part/TableChart/mixins/TableChartMixins";
import TitleCover from "@/components/echarts-part/kpi/sith/cells/TitleCover.vue";

export default {
    name: "IncomingStatus",
    components: {TitleCover, CommonChart},
    mixins: [TableChartMixins],
    computed: {
        historyOption() {
            return {
                title: {
                    show: false,
                    text: '历史物料入厂状态',
                    textStyle: {
                        color: '#fff',
                        fontSize: _pxGenerator(0.22)
                    },
                    top: '4%',
                    left: '10%'
                },
                grid: {
                    bottom: '20%',
                    top: '12%',
                    right: '5%'
                },
                legend: {
                    show: true,
                    data: ['103-ITEM', '105-ITEM', '入库-ITEM', '\n', '103-DAYS', '105-DAYS', '入库-DAYS'],
                    textStyle: {
                        color: '#fff',
                        fontSize: _pxGenerator(this.fs),
                    },
                    bottom: 0,
                    padding: _pxGenerator(0.03),
                    itemWidth: _pxGenerator(0.25),
                    itemHeight: _pxGenerator(0.14),
                    itemGap: _pxGenerator(0.06),
                },
                xAxis: {
                    type: 'category',
                    data: this.xAxis,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        margin: _pxGenerator(0.04),
                        fontSize: _pxGenerator(this.fs),
                    }
                },
                yAxis: [
                    {
                        name: 'ITEM',
                        type: "value",
                        nameTextStyle: {
                            fontSize: _pxGenerator(this.fs)
                        },
                        nameGap: _pxGenerator(0.15),
                        axisLabel: {
                            fontSize: _pxGenerator(this.fs),
                            margin: _pxGenerator(0.02)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#575665'
                            },
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    {
                        name: 'DAY',
                        type: "value",
                        nameTextStyle: {
                            fontSize: _pxGenerator(this.fs)
                        },
                        nameGap: _pxGenerator(0.15),
                        axisLabel: {
                            fontSize: _pxGenerator(this.fs),
                            margin: _pxGenerator(0.02)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#575665'
                            },
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    }
                ],
                series: [
                    {
                        name: "103-ITEM",
                        data: this.history_103.map(o => o.count),
                        type: "bar",
                        color: '#e0edee'
                    },
                    {
                        name: "105-ITEM",
                        data: this.history_105.map(o => o.count),
                        type: "bar",
                        color: '#6d74d5'
                    },
                    {
                        name: "入库-ITEM",
                        data: this.history_input.map(o => o.count),
                        type: "bar",
                        color: '#7c16e5'
                    },

                    {
                        name: "103-DAYS",
                        data: this.history_103.map(o => o.avg),
                        type: "line",
                        color: '#50b1b0',
                        yAxisIndex: 1
                    },
                    {
                        name: "105-DAYS",
                        data: this.history_105.map(o => o.avg),
                        type: "line",
                        color: '#ece54b',
                        yAxisIndex: 1
                    },
                    {
                        name: "入库-DAYS",
                        data: this.history_input.map(o => o.avg),
                        type: "line",
                        color: '#89c471',
                        yAxisIndex: 1
                    },
                ]
            };
        },
        currentOption() {
            return {
                title: {
                    show: false,
                    text: '当月物料入厂状态',
                    textStyle: {
                        color: '#fff',
                        fontSize: _pxGenerator(0.20)
                    },
                    top: '4%',
                    left: '10%'
                },
                grid: {
                    bottom: '20%',
                    top: '12%',
                    left: '12%'
                },
                legend: {
                    show: true,
                    textStyle: {
                        color: '#fff',
                        fontSize: _pxGenerator(this.fs),
                    },
                    bottom: '5%',
                    itemWidth: _pxGenerator(0.25),
                    itemHeight: _pxGenerator(0.14),
                    itemGap: _pxGenerator(0.1),
                },
                xAxis: {
                    type: 'category',
                    data: ['103', '105', '入库'],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        margin: _pxGenerator(0.04),
                        fontSize: _pxGenerator(this.fs),
                    }
                },
                yAxis: [
                    {
                        name: 'ITEM',
                        type: "value",
                        nameTextStyle: {
                            fontSize: _pxGenerator(this.fs)
                        },
                        nameGap: _pxGenerator(0.15),
                        axisLabel: {
                            fontSize: _pxGenerator(this.fs),
                            margin: _pxGenerator(0.02)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#575665'
                            },
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    {
                        name: 'DAY',
                        type: "value",
                        nameTextStyle: {
                            fontSize: _pxGenerator(this.fs)
                        },
                        nameGap: _pxGenerator(0.15),
                        axisLabel: {
                            fontSize: _pxGenerator(this.fs),
                            margin: _pxGenerator(0.02)
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#575665'
                            },
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                    }
                ],
                series: [
                    {
                        name: "ITEM",
                        data: this.items,
                        type: "bar",
                        barMaxWidth: '40%',
                        color: '#aa89e9'
                    },
                    {
                        name: "DAYS",
                        data: this.days,
                        type: "line",
                        yAxisIndex: 1,
                        color: '#fff'
                    },
                ]
            };
        },
        xAxis() {
            let halfYearAgo = new Date();
            halfYearAgo.setMonth(halfYearAgo.getMonth() - 6);
            let lastMonth = new Date();
            lastMonth.setMonth(lastMonth.getMonth() - 1);
            return this.splitDateByUnit(halfYearAgo, lastMonth, 2);
        },
    },
    data() {
        return {
            fs: 0.12,

            history_103: [],
            history_105: [],
            history_input: [],

            items: [0, 0, 0],
            days: [0, 0, 0],

            incoming_interval: null
        }
    },
    mounted() {
        this.getRemoteData();
        this.incoming_interval = setInterval(function () {
            const now = new Date();
            if (now.getHours() === 1 && now.getMinutes() === 0) {
                this.getRemoteData();
                console.log('interval')
            }
        }, 60000);
    },
    beforeDestroy() {
        if (this.incoming_interval) {
            clearInterval(this.incoming_interval);
        }
    },
    methods: {
        getRemoteData() {
            //103
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryItem/cal103StatusLayout",
                commonErrorHandle: false
            }).then(response => {
                console.log('103', response);
                this.history_103 = response.slice(0, 6);
                this.$set(this.items, 0, response[6].count);
                this.$set(this.days, 0, response[6].avg);
            })
            //105
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryReceiptReturnRecord/cal105StatusLayout",
                commonErrorHandle: false
            }).then(response => {
                console.log('105', response);
                this.history_105 = response.slice(0, 6);
                this.$set(this.items, 1, response[6].count);
                this.$set(this.days, 1, response[6].avg);
            })
            //input
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryStorageInput/calInputStatusLayout",
                commonErrorHandle: false
            }).then(response => {
                console.log('input', response);
                this.history_input = response.slice(0, 6);
                this.$set(this.items, 2, response[6].count);
                this.$set(this.days, 2, response[6].avg);
            })
        },
    },
}
</script>

<style scoped>
.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
